var tt = Object.defineProperty;
var et = (e, t, o) => t in e ? tt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o;
var K = (e, t, o) => et(e, typeof t != "symbol" ? t + "" : t, o);
import { jsxs as ot, jsx as $ } from "react/jsx-runtime";
import nt, { useContext as st, createContext as lt, useMemo as Y, useState as j, useRef as U, useCallback as rt, useEffect as Z } from "react";
import { p as M, f as it } from "./config.mjs";
import { debounce as ct, createSmoothScroll as at } from "@vavt/util";
class ft {
  constructor() {
    // 事件池
    K(this, "pools", {});
  }
  // 移除事件监听
  remove(t, o, n) {
    const d = this.pools[t] && this.pools[t][o];
    d && (this.pools[t][o] = d.filter((h) => h !== n));
  }
  // 清空全部事件，由于单一实例，多次注册会被共享内容
  clear(t) {
    this.pools[t] = {};
  }
  // 注册事件监听
  on(t, o) {
    return this.pools[t] || (this.pools[t] = {}), this.pools[t][o.name] || (this.pools[t][o.name] = []), this.pools[t][o.name].push(o.callback), this.pools[t][o.name].includes(o.callback);
  }
  // 触发事件
  emit(t, o, ...n) {
    this.pools[t] || (this.pools[t] = {});
    const d = this.pools[t][o];
    d && d.forEach((h) => {
      try {
        h(...n);
      } catch (u) {
        console.error(`${o} monitor event exception！`, u);
      }
    });
  }
}
const W = new ft(), Ht = "onSave", Lt = "changeCatalogVisible", St = "changeFullscreen", At = "pageFullscreenChanged", Nt = "fullscreenChanged", bt = "previewChanged", Rt = "previewOnlyChanged", _t = "htmlPreviewChanged", xt = "catalogVisibleChanged", kt = "buildFinished", It = "errorCatcher", wt = "replace", yt = "uploadImage", Mt = "openModals", $t = "ctrlZ", Ot = "ctrlShiftZ", z = "catalogChanged", dt = "pushCatalog", Bt = "rerender", Dt = "eventListener", Pt = "taskStateChanged", Gt = (e, t = "image.png") => {
  const o = e.split(","), n = o[0].match(/:(.*?);/);
  if (n) {
    const v = n[1], d = atob(o[1]);
    let h = d.length;
    const u = new Uint8Array(h);
    for (; h--; )
      u[h] = d.charCodeAt(h);
    return new File([u], t, { type: v });
  }
  return null;
}, Ft = (e, t) => {
  if (!e)
    return e;
  const o = t.split(`
`), n = ['<span rn-wrapper aria-hidden="true">'];
  return o.forEach(() => {
    n.push("<span></span>");
  }), n.push("</span>"), `<span class="${M}-code-block">${e}</span>${n.join("")}`;
}, J = (e) => e.filter((t) => t !== !1).join(" "), ht = (e, t) => {
  if (!e || !t)
    return 0;
  const o = e == null ? void 0 : e.getBoundingClientRect();
  if (t === document.documentElement)
    return o.top - t.clientTop;
  const n = t == null ? void 0 : t.getBoundingClientRect();
  return o.top - n.top;
}, Vt = /* @__PURE__ */ (() => {
  let e = 0;
  return (t) => t + ++e;
})(), Ut = /* @__PURE__ */ (() => {
  let e = 0;
  return () => ++e;
})(), ut = `.${M}-preview > [data-line]`, G = (e, t) => +getComputedStyle(e).getPropertyValue(t).replace("px", ""), qt = (e, t) => {
  const o = ct(() => {
    e.removeEventListener("scroll", n), e.addEventListener("scroll", n), t.removeEventListener("scroll", n), t.addEventListener("scroll", n);
  }, 50), n = (v) => {
    const d = e.clientHeight, h = t.clientHeight, u = e.scrollHeight, f = t.scrollHeight, g = (u - d) / (f - h);
    v.target === e ? (t.removeEventListener("scroll", n), t.scrollTo({
      top: e.scrollTop / g
      // behavior: 'smooth'
    }), o()) : (e.removeEventListener("scroll", n), e.scrollTo({
      top: t.scrollTop * g
      // behavior: 'smooth'
    }), o());
  };
  return [
    () => {
      o().finally(() => {
        e.dispatchEvent(new Event("scroll"));
      });
    },
    () => {
      e.removeEventListener("scroll", n), t.removeEventListener("scroll", n);
    }
  ];
}, jt = (e, t, o) => {
  const { view: n } = o, v = at(), d = (s) => n.lineBlockAt(n.state.doc.line(s + 1).from).top, h = (s) => n.lineBlockAt(n.state.doc.line(s + 1).from).bottom;
  let u = [], f = [], g = [];
  const T = () => {
    u = [], f = Array.from(
      t.querySelectorAll(ut)
    ), g = f.map((l) => Number(l.dataset.line));
    const s = [...g], { lines: a } = n.state.doc;
    let m = s.shift() || 0, i = s.shift() || a;
    for (let l = 0; l < a; l++)
      l === i && (m = l, i = s.shift() || a), u.push({
        start: m,
        end: i - 1
      });
  }, x = (s, a) => {
    let m = 1;
    for (let i = f.length - 1; i - 1 >= 0; i--) {
      const l = f[i], r = f[i - 1];
      if (l.offsetTop + l.offsetHeight > a && r.offsetTop < a) {
        m = Number(r.dataset.line);
        break;
      }
    }
    for (let i = u.length - 1; i >= 0; i--) {
      const l = h(u[i].end), r = d(u[i].start);
      if (l > s && r <= s) {
        m = m < u[i].start ? m : u[i].start;
        break;
      }
    }
    return m;
  };
  let A = 0, N = 0;
  const q = () => {
    var O, B, D;
    if (N !== 0)
      return !1;
    A++;
    const { scrollDOM: s, contentHeight: a } = n;
    let m = G(t, "padding-top");
    const i = n.lineBlockAtHeight(s.scrollTop), { number: l } = n.state.doc.lineAt(i.from), r = u[l - 1];
    if (!r)
      return !1;
    let c = 1;
    const p = t.querySelector(`[data-line="${r.start}"]`) || ((O = t.firstElementChild) == null ? void 0 : O.firstElementChild), E = t.querySelector(`[data-line="${r.end + 1}"]`) || ((B = t.lastElementChild) == null ? void 0 : B.lastElementChild), S = s.scrollHeight - s.clientHeight, k = t.scrollHeight - t.clientHeight;
    let H = d(r.start), I = h(r.end), b = p.offsetTop, R = E.offsetTop - b;
    H === 0 && (b = 0, p === E ? (m = 0, I = a - s.offsetHeight, R = k) : R = E.offsetTop), c = (s.scrollTop - H) / (I - H);
    const F = E == ((D = t.lastElementChild) == null ? void 0 : D.lastElementChild) ? E.offsetTop + E.clientHeight : E.offsetTop;
    if (I >= S || F > k) {
      const P = x(S, k);
      H = d(P), c = (s.scrollTop - H) / (S - H);
      const _ = t.querySelector(`[data-line="${P}"]`);
      H > 0 && _ && (b = _.offsetTop), R = k - b + G(t, "padding-top");
    }
    const V = b - m + R * c;
    v(t, V, () => {
      A--;
    });
  }, w = () => {
    var F, V, O, B, D, P;
    if (A !== 0)
      return;
    N++;
    const { scrollDOM: s } = n, a = t.scrollTop, m = t.scrollHeight, i = s.scrollHeight - s.clientHeight, l = t.scrollHeight - t.clientHeight;
    let r = (F = t.firstElementChild) == null ? void 0 : F.firstElementChild, c = (V = t.firstElementChild) == null ? void 0 : V.lastElementChild;
    if (g.length > 0) {
      let _ = Math.ceil(
        g[g.length - 1] * (a / m)
      ), C = g.findLastIndex((L) => L <= _);
      C = C === -1 ? 0 : C, _ = g[C];
      for (let L = C; L >= 0 && L < g.length; )
        if (f[L].offsetTop > a) {
          if (L - 1 >= 0) {
            L--;
            continue;
          }
          _ = -1, C = L;
          break;
        } else {
          if (L + 1 < g.length && f[L + 1].offsetTop < a) {
            L++;
            continue;
          }
          _ = g[L], C = L;
          break;
        }
      switch (C) {
        case -1: {
          r = (O = t.firstElementChild) == null ? void 0 : O.firstElementChild, c = f[C];
          break;
        }
        case g.length - 1: {
          r = f[C], c = (B = t.firstElementChild) == null ? void 0 : B.lastElementChild;
          break;
        }
        default:
          r = f[C], c = f[C + 1 === f.length ? C : C + 1];
      }
    }
    let p = r === ((D = t.firstElementChild) == null ? void 0 : D.firstElementChild) ? 0 : r.offsetTop - G(r, "margin-top"), E = c.offsetTop, S = 0;
    const { start: k, end: H } = u[Number(r.dataset.line || 0)];
    let I = d(k);
    const b = d(
      H + 1 === n.state.doc.lines ? H : H + 1
    );
    let R = 0;
    if (b > i || c.offsetTop + c.offsetHeight > l) {
      const _ = x(i, l), C = t.querySelector(`[data-line="${_}"]`);
      p = C ? C.offsetTop - G(C, "margin-top") : p, I = d(_), S = (a - p) / (l - p), R = i - I;
    } else r === ((P = t.firstElementChild) == null ? void 0 : P.firstElementChild) ? (r === c && (E = c.offsetTop + c.offsetHeight + +getComputedStyle(c).marginBottom.replace("px", "")), R = b, S = Math.max(a / E, 0)) : (S = Math.max(
      (a - p) / (E - p),
      0
    ), R = b - I);
    v(e, I + R * S, () => {
      N--;
    });
  }, y = (s) => {
    var l;
    const { scrollDOM: a, contentHeight: m } = n, i = a.clientHeight;
    if (m <= i || t.firstElementChild.clientHeight <= t.clientHeight || n.state.doc.lines <= ((l = u[u.length - 1]) == null ? void 0 : l.end))
      return !1;
    s.target === e ? q() : w();
  };
  return [
    () => {
      T(), e.addEventListener("scroll", y), t.addEventListener("scroll", y), e.dispatchEvent(new Event("scroll"));
    },
    () => {
      e.removeEventListener("scroll", y), t.removeEventListener("scroll", y);
    }
  ];
}, Q = ({
  tocItem: e,
  mdHeadingId: t,
  onClick: o,
  scrollElementOffsetTop: n = 0
}) => {
  const { scrollElementRef: v, rootNodeRef: d } = st(X);
  return /* @__PURE__ */ ot(
    "div",
    {
      className: J([
        `${M}-catalog-link`,
        e.active && `${M}-catalog-active`
      ]),
      onClick: (h) => {
        o && o(h, e), h.stopPropagation();
        const u = t(e.text, e.level, e.index), f = d == null ? void 0 : d.current.getElementById(u), g = v == null ? void 0 : v.current;
        if (f && g) {
          let T = f.offsetParent, x = f.offsetTop;
          if (g.contains(T))
            for (; T && g != T; )
              x += T == null ? void 0 : T.offsetTop, T = T == null ? void 0 : T.offsetParent;
          const A = f.previousElementSibling;
          let N = 0;
          A || (N = G(f, "margin-top")), g == null || g.scrollTo({
            top: x - n - N,
            behavior: "smooth"
          });
        }
      },
      children: [
        /* @__PURE__ */ $("span", { title: e.text, children: e.text }),
        /* @__PURE__ */ $("div", { className: `${M}-catalog-wrapper`, children: e.children && e.children.map((h) => /* @__PURE__ */ $(
          Q,
          {
            mdHeadingId: t,
            tocItem: h,
            onClick: o,
            scrollElementOffsetTop: n
          },
          `${h.text}-${h.index}`
        )) })
      ]
    }
  );
}, X = lt({
  scrollElementRef: void 0,
  rootNodeRef: void 0
}), gt = (e) => {
  const {
    editorId: t,
    mdHeadingId: o = it.mdHeadingId,
    theme: n = "light",
    offsetTop: v = 20
  } = e, d = Y(() => `#${t}-preview-wrapper`, [t]), [h, u] = j([]), [f, g] = j(), T = U(null), x = U(), A = U(), N = U(), q = Y(() => {
    const s = [];
    return h.forEach((a, m) => {
      const { text: i, level: l } = a, r = {
        level: l,
        text: i,
        index: m + 1,
        active: f === a
      };
      if (s.length === 0)
        s.push(r);
      else {
        let c = s[s.length - 1];
        if (r.level > c.level)
          for (let p = c.level + 1; p <= 6; p++) {
            const { children: E } = c;
            if (!E) {
              c.children = [r];
              break;
            }
            if (c = E[E.length - 1], r.level <= c.level) {
              E.push(r);
              break;
            }
          }
        else
          s.push(r);
      }
    }), s;
  }, [f, h]), [w] = j(() => e.scrollElement || `#${t}-preview-wrapper`), y = rt(() => {
    var a;
    if (w instanceof HTMLElement)
      return w;
    let s = document;
    return (w === d || e.isScrollElementInShadow) && (s = (a = T.current) == null ? void 0 : a.getRootNode()), s.querySelector(w);
  }, [d, e.isScrollElementInShadow, w]);
  return Z(() => {
    N.current = T.current.getRootNode();
  }, []), Z(() => {
    let s = [];
    const a = (l) => {
      if (l.length === 0)
        return u([]), !1;
      const { activeHead: r } = l.reduce(
        (c, p, E) => {
          var k;
          const S = (k = N.current) == null ? void 0 : k.getElementById(
            o(p.text, p.level, E + 1)
          );
          if (S instanceof HTMLElement) {
            const H = ht(S, x.current);
            if (H < v && H > c.minTop)
              return {
                activeHead: p,
                minTop: H
              };
          }
          return c;
        },
        {
          activeHead: l[0],
          minTop: Number.MIN_SAFE_INTEGER
        }
      );
      g(r), u(l), s = l;
    }, m = () => {
      a(s);
    }, i = (l) => {
      var c, p;
      const r = y();
      x.current = r, A.current = r === document.documentElement ? document : r, (c = A.current) == null || c.removeEventListener("scroll", m), a(l), (p = A.current) == null || p.addEventListener("scroll", m);
    };
    return W.on(t, {
      name: z,
      callback: i
    }), W.emit(t, dt), () => {
      var l;
      W.remove(t, z, i), (l = A.current) == null || l.removeEventListener("scroll", m);
    };
  }, [v, o, y, t]), Z(() => {
    e.onActive && e.onActive(f);
  }, [f, e]), /* @__PURE__ */ $(
    X.Provider,
    {
      value: {
        scrollElementRef: x,
        rootNodeRef: N
      },
      children: /* @__PURE__ */ $(
        "div",
        {
          className: J([
            `${M}-catalog`,
            n === "dark" && `${M}-catalog-dark`,
            e.className || ""
          ]),
          style: e.style,
          ref: T,
          children: q.map((s) => /* @__PURE__ */ $(
            Q,
            {
              mdHeadingId: o,
              tocItem: s,
              onClick: e.onClick,
              scrollElementOffsetTop: e.scrollElementOffsetTop
            },
            `${s.text}-${s.index}`
          ))
        }
      )
    }
  );
}, Zt = nt.memo(gt);
export {
  kt as B,
  Lt as C,
  It as E,
  Nt as F,
  _t as H,
  Zt as M,
  Ht as O,
  At as P,
  Bt as R,
  Pt as T,
  yt as U,
  bt as a,
  W as b,
  J as c,
  Rt as d,
  xt as e,
  St as f,
  Vt as g,
  wt as h,
  Dt as i,
  Ut as j,
  Gt as k,
  Mt as l,
  Ot as m,
  $t as n,
  qt as o,
  Ft as p,
  z as q,
  dt as r,
  jt as s,
  X as t
};
